module.exports = __webpack_public_path__ + "static/media/document-loading-blue.11cd74b7.svg";